const ModalHeader = ({ title }) => {
	return (
		<div className="flex pt-8 border-b-2 border-gray-300">
			<h1 className="font-medium text-4xl text-black">{title}</h1>
		</div>
	);
};

export default ModalHeader;
